// extracted by mini-css-extract-plugin
module.exports = {"contHolder":"CreateCommentBar_contHolder__NL_qF","container":"CreateCommentBar_container__2B6jT","commentInput":"CreateCommentBar_commentInput__2EKsJ"};